import {
  GET_ROSTER_ADHERENCE,
  GET_ROSTER_ADHERENCE_SUCCESS,
  GET_ROSTER_ADHERENCE_ERROR,
  GET_CLIENT_ADHERENCE,
  GET_CLIENT_ADHERENCE_SUCCESS,
  GET_CLIENT_ADHERENCE_ERROR,
} from './constants';

/**
 * Fetch the trainer's roster-wide adherence snapshot. Returns one row
 * per visible client with `latestPct` + `trend: number[]` for the
 * Adherence + Trend columns on the Your Roster page.
 */
export function getRosterAdherence(weeks = 8) {
  return { type: GET_ROSTER_ADHERENCE, weeks };
}
export function getRosterAdherenceSuccess(payload) {
  return { type: GET_ROSTER_ADHERENCE_SUCCESS, payload };
}
export function getRosterAdherenceError(err) {
  return { type: GET_ROSTER_ADHERENCE_ERROR, err };
}

/**
 * Fetch one client's weekly adherence (workout + meal-log channels) for
 * the detail page's stacked-bar chart.
 */
export function getClientAdherence(clientId, weeks = 8) {
  return { type: GET_CLIENT_ADHERENCE, clientId, weeks };
}
export function getClientAdherenceSuccess(payload) {
  return { type: GET_CLIENT_ADHERENCE_SUCCESS, payload };
}
export function getClientAdherenceError(err) {
  return { type: GET_CLIENT_ADHERENCE_ERROR, err };
}
